import React from 'react';
import { LuCalendarCheck } from 'react-icons/lu';
import { LuStethoscope } from 'react-icons/lu';
import { IoChatboxEllipsesOutline } from 'react-icons/io5';

const InfoContent = () => {
  return (
    <div className="w-full bg-white flex justify-center">
      <div className="max-w-screen-2xl sm:py-28 py-16 px-4 justify-start lg:justify-center items-center flex flex-col lg:flex-row lg:gap-32 gap-8">
        <div>
          <h3 className="text-teal-500 font-bold mb-9">Mais simples e inteligente</h3>
          <h1 className="w-full text-teal-800 font-bold">
            Consultas com dermatologistas, sem precisar perder tempo ou mesmo sair
            de casa
          </h1>
        </div>

        <div>
          <div className="flex justify-start items-start gap-4 mb-9">
            <LuCalendarCheck size={36} color={'#14B8A6'} />
            <div className="flex-col justify-start items-start gap-1 flex">
              <h4 className="text-teal-800 font-bold">Agendamento Simplificado</h4>
              <p className="leading-5">
                Chega de complicações! Agende suas consultas com dermatologistas em poucos cliques e otimize
                seu tempo para o que realmente importa.
              </p>
            </div>
          </div>
          <div className="flex justify-start items-start gap-4 mb-9">
            <LuStethoscope size={36} color={'#14B8A6'} />
            <div className=" flex-col justify-start items-start gap-1 flex">
              <h4 className="text-teal-800 font-bold">
                Busca inteligente por Dermatologista:
              </h4>
              <p className="leading-5">
                Encontre o profissional certo para suas necessidades de saúde através de
                nossa busca intuitiva por especialidade médica.
              </p>
            </div>
          </div>
          <div className="flex justify-start items-start gap-4">
            <IoChatboxEllipsesOutline size={46} color={'#14B8A6'} />
            <div className="flex-col justify-start items-start gap-1 flex">
              <h4 className="text-teal-800 font-bold">Notificações Personalizadas:</h4>
              <p className="leading-5">
                Fique sempre atualizado! Receba lembretes de consultas, confirmações e
                outras informações importantes, personalizadas de acordo com suas
                preferências.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoContent;
